<template>
  <div class="flex flex-1 flex-col">
    <div class="flex flex-1 px-4 py-12">
      <section class="mx-auto w-full max-w-md space-y-6">
        <div class="space-y-3 text-center">
          <h1 class="text-3xl font-semibold text-slate-900">Loo konto</h1>
          <p class="text-sm text-slate-500">
            Registreeru, et hallata postitusi ja taotlusi ühest kohast.
          </p>
        </div>

        <form
          @submit.prevent="SignUp"
          class="rounded-3xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-900/5 sm:p-8"
        >
          <div class="space-y-5">
            <div class="space-y-2">
              <label for="email" class="text-sm font-semibold text-slate-700">Email</label>
              <input
                id="email"
                type="email"
                placeholder="Email"
                v-model.trim="email"
                required
                class="w-full rounded-2xl border border-slate-200/80 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm transition focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/30"
              />
            </div>

            <div class="space-y-2">
              <label for="password" class="text-sm font-semibold text-slate-700">Salasõna</label>
              <input
                id="password"
                type="password"
                placeholder="Salasõna"
                v-model="password"
                @input="validatePassword"
                required
                class="w-full rounded-2xl border border-slate-200/80 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm transition focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/30"
              />
              <p class="text-xs text-slate-500">
                Salasõna peab algama suure tähega, sisaldama numbrit, kahte väiketähte ja "_" märki.
              </p>
            </div>

            <p
              v-if="errorMessage"
              class="rounded-2xl bg-red-50 px-4 py-3 text-xs font-medium text-red-600"
              role="alert"
            >
              {{ errorMessage }}
            </p>
          </div>

          <button
            type="submit"
            :disabled="!validPass"
            class="mt-8 inline-flex w-full items-center justify-center rounded-xl bg-brand px-4 py-3 text-sm font-semibold uppercase tracking-wide text-white shadow-lg shadow-brand/20 transition hover:bg-brand-dark focus:outline-none focus:ring-4 focus:ring-brand/40 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Signup
          </button>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignupView",
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      validPass: false,
    };
  },
  methods: {
    validatePassword() {
      const password = this.password;
      const errors = [];

      if (password.length < 8 || password.length > 15) {
        errors.push("Password must be between 8 and 15 characters.");
      }
      if (!/^[A-Z]/.test(password)) {
        errors.push("Password must start with an uppercase letter.");
      }
      if (!/[0-9]/.test(password)) {
        errors.push("Password must include at least one number.");
      }
      if ((password.match(/[a-z]/g) || []).length < 2) {
        errors.push("Password must include at least two lowercase letters.");
      }
      if (!/_/.test(password)) {
        errors.push('Password must include the character "_".');
      }

      this.validPass = errors.length === 0;
      this.errorMessage = errors.length ? errors.join(" ") : "";
    },
    async SignUp() {
      if (!this.validPass) return;
      const payload = { email: this.email, password: this.password };
      try {
        const response = await fetch("http://localhost:3000/auth/signup", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          throw new Error(`Signup failed: ${response.status}`);
        }
        await response.json();
        this.$router.push("/");
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style scoped></style>
